module.exports = __webpack_public_path__ + "img/arrow_none.3954333e.svg";